module.exports = __webpack_public_path__ + "img/upload-icon.7de4533b.svg";